import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { variantAttributeKeys } from "./keys";

import { VariantAttribute, VariantAttributeFilter } from "@/types/product";
import { OffsetPaginationResponse } from "@/types/pagination";
import { useGlobalStore } from "@/stores/global";
import { isMockEnabled, simulateDelay } from "@/mock/config";
import { getVariantAttributesMock } from "@/mock/handlers/variant-attribute";

import { api } from "@/lib/api-client";

export const useGetVariantAttributes = (
  filters: VariantAttributeFilter = {}
) => {
  const { activeWorkspaceId } = useGlobalStore();

  return useQuery({
    queryKey: variantAttributeKeys.list(activeWorkspaceId ?? "", filters),
    queryFn: async () => {
      if (isMockEnabled()) {
        await simulateDelay();
        return getVariantAttributesMock(filters);
      }
      const searchParams = new URLSearchParams();

      searchParams.set("page", String(filters.page ?? 1));
      searchParams.set("limit", String(filters.limit ?? 100));

      const data = await api
        .get("variant-attributes", { searchParams })
        .json<OffsetPaginationResponse<VariantAttribute>>();

      return data.data.result;
    },
    placeholderData: keepPreviousData,
    enabled: !!activeWorkspaceId,
  });
};
